import type { HTMLAttributes } from "@builder.io/qwik";
import { component$, Slot } from "@builder.io/qwik";
import { cn } from "~/lib/cn";

export const Card = component$(
  (props: HTMLAttributes<HTMLDivElement> & { error?: unknown }) => {
    const { class: className, ...rest } = props;
    return (
      <div
        class={cn(
          "bg-card text-card-foreground rounded-lg border border-gray-100 shadow-sm transition hover:shadow-md",
          {
            "border-red-700": props.error,
          },
          className,
        )}
        {...rest}
      >
        <Slot />
      </div>
    );
  },
);

export const CardHeader = component$(
  (props: HTMLAttributes<HTMLDivElement>) => {
    const { class: className, ...rest } = props;
    return (
      <div class={cn("flex flex-col gap-2 p-6 pb-0", className)} {...rest}>
        <Slot />
      </div>
    );
  },
);

export const CardTitle = component$(
  (props: HTMLAttributes<HTMLHeadingElement>) => {
    const { class: className, ...rest } = props;
    return (
      <h3
        class={cn(
          "font-heading pb-2 text-xl leading-tight tracking-tight",
          className,
        )}
        {...rest}
      >
        <Slot />
      </h3>
    );
  },
);

export const CardDescription = component$(
  (props: HTMLAttributes<HTMLParagraphElement>) => {
    const { class: className, ...rest } = props;
    return (
      <p class={cn("text-muted-foreground text-sm", className)} {...rest}>
        <Slot />
      </p>
    );
  },
);

export const CardContent = component$(
  (props: HTMLAttributes<HTMLDivElement>) => {
    const { class: className, ...rest } = props;
    return (
      <div class={cn("p-6", className)} {...rest}>
        <Slot />
      </div>
    );
  },
);

export const CardFooter = component$(
  (props: HTMLAttributes<HTMLDivElement>) => {
    const { class: className, ...rest } = props;
    return (
      <div class={cn("flex items-center pt-4", className)} {...rest}>
        <Slot />
      </div>
    );
  },
);
